import React from 'react'
import {useNoticeListQueryData} from 'src/hooks/reactquery'
import {useMoreButton} from 'src/hooks/useMoreButton'
import {convertDateFormat} from 'src/service/utils'
import {Link} from 'react-router-dom'
import {COLOR} from 'src/service/constant/color'
import {NoticeList, NoticeWrap} from 'src/styles/views/Support/Notice'
import {TYPE_NOTICELIST} from 'src/service/constant/cmdtype'
import {CustomBtn} from 'src/styles/common/CommonForm/buttonform'
import useWindowDimensions from 'src/hooks/useGetWindowSize'
import Loading from 'src/component/common/Loading'
import arrow from "src/assets/health/health_arrow_img.png"

const Notice = () => {
    const {width} = useWindowDimensions()
    const [more, onChangeMore] = useMoreButton(0)
    const {isLoading, data: NoticeListData} = useNoticeListQueryData(TYPE_NOTICELIST, more)
    return (

        <NoticeWrap>
            {isLoading && <Loading/>}
            {NoticeListData?.Body?.map((option: any, index: number) => (
                <NoticeList key={index} line={`${index === 0 && 'true'}`}>
                    <Link to={`/notice/detail/${option?.Idx}`}>
                        {option?.Title}
                    </Link>
                    <span>{convertDateFormat(option.StartTime)}</span>
                </NoticeList>
            ))}
            {NoticeListData?.Body?.length >= (more + 1) * 6 && (
                <CustomBtn
                    className={width > 1200 ? "health_btn_pc" : "health_btn_mo"}
                    color={COLOR.point1}
                    bgColor={COLOR.white}
                    borderRadius={"40px"}
                    borderColor={COLOR.point1}
                    marginTop={width > 1200 ? "68px" : "38px"}
                    width={width > 1200 ? "356px" : "328px"}
                    height={width > 1200 ? "56px" : "44px"}
                    fontSize={width > 1200 ? "18px" : "14px"}
                    fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                    onClick={onChangeMore}
                >
                    <img src={arrow} alt=''/>
                    <span>더보기</span>
                </CustomBtn>
            )}
        </NoticeWrap>

    )
}
export default Notice
